<div class="flex flex-col sm:flex-row sm:items-end gap-2 w-full mb-3">
  <div class="flex items-end flex-wrap gap-2 flex-1 min-w-0">
    <ng-container #defaultFiltersContainer></ng-container>
    <!-- Optional controls a host places right after its default filters. -->
    <ng-content select="[filterContainerAfterDefaults]" />

    <!-- Divider (only show if there are additional filters) -->
    @if (activeAdditionalFilters().size > 0) {
      <div class="m-0 p-0 self-end h-6 w-px bg-base-300 mx-0 mb-1"></div>
    }

    <!-- Additional filters -->
    <ng-container #additionalFiltersContainer></ng-container>

    <!-- Additional filters dropdown -->
    @if (showAddFilterButton()) {
      <div class="relative inline-flex items-center shrink-0">
        @if (addFilterLabel()) {
          <button
            #addFilterButton
            type="button"
            class="flex items-center gap-1.5 px-4 py-2 border border-base-300 rounded-full bg-base-100 text-base-content text-xs font-medium cursor-pointer transition-all duration-200 ease-in-out shrink-0 hover:bg-primary hover:text-primary-content hover:border-primary"
            (click)="toggleAdditionalDropdown()"
            [attr.aria-expanded]="showAdditionalDropdown()"
            aria-label="Add additional filters">
            <fa-icon [icon]="faPlus" class="text-[10px]"></fa-icon>
            {{ addFilterLabel() }}
          </button>
        } @else {
          <button
            #addFilterButton
            type="button"
            class="flex items-center gap-1.5 px-4 py-2 border border-base-300 rounded-full bg-base-100 text-base-content text-xs font-medium cursor-pointer transition-all duration-200 ease-in-out shrink-0 hover:bg-primary hover:text-primary-content hover:border-primary"
            (click)="toggleAdditionalDropdown()"
            [attr.aria-expanded]="showAdditionalDropdown()"
            aria-label="More filters">
            <fa-icon [icon]="faPlus" class="text-[10px]"></fa-icon>
            More Filters
          </button>
        }
        @if (showAdditionalDropdown()) {
          <div
            class="fixed top-0 left-0 right-0 bottom-0 z-[500] bg-transparent cursor-default"
            (click)="toggleAdditionalDropdown()"></div>
          <div
            appKeepInViewport
            class="fixed flex flex-col p-2 bg-base-100 border border-base-300 rounded-3xl shadow-lg z-[501] w-[calc(100vw-2rem)] sm:w-auto min-w-[300px] max-w-[400px] max-h-[80vh]"
            [class.max-sm:top-1/2]="!dropdownOverlay()"
            [class.max-sm:left-1/2]="!dropdownOverlay()"
            [class.max-sm:-translate-x-1/2]="!dropdownOverlay()"
            [class.max-sm:-translate-y-1/2]="!dropdownOverlay()"
            [class.sm:absolute]="!dropdownOverlay()"
            [class.sm:top-[calc(100%+8px)]]="!dropdownOverlay()"
            [class.sm:left-0]="
              !dropdownOverlay() && additionalDropdownAlign() === 'left'
            "
            [class.sm:right-auto]="
              !dropdownOverlay() && additionalDropdownAlign() === 'left'
            "
            [class.sm:left-auto]="
              !dropdownOverlay() && additionalDropdownAlign() === 'right'
            "
            [class.sm:right-0]="
              !dropdownOverlay() && additionalDropdownAlign() === 'right'
            "
            [class.top-1/2]="dropdownOverlay()"
            [class.left-1/2]="dropdownOverlay()"
            [class.-translate-x-1/2]="dropdownOverlay()"
            [class.-translate-y-1/2]="dropdownOverlay()"
            (click)="$event.stopPropagation()">
            <div class="px-2 pt-1 pb-2">
              <div class="relative">
                <fa-icon
                  [icon]="faMagnifyingGlass"
                  class="absolute left-3 top-1/2 -translate-y-1/2 text-base-content/40 text-xs"></fa-icon>
                <input
                  #dropdownSearchInput
                  type="text"
                  [id]="additionalSearchInputId"
                  name="filter-container-additional-search"
                  autocomplete="off"
                  class="input input-sm input-bordered w-full pl-8 rounded-xl text-xs"
                  placeholder="Search filters..."
                  [ngModel]="dropdownSearch()"
                  (ngModelChange)="dropdownSearch.set($event)"
                  (mousedown)="$event.stopPropagation()" />
              </div>
            </div>
            <div class="overflow-y-auto">
              @if (
                filteredAdditionalFilters().length > 0 && !dropdownSearch()
              ) {
                <button
                  type="button"
                  class="flex w-[calc(100%-1rem)] items-center gap-3 px-4 rounded-xl mx-2 py-3 text-left hover:bg-base-200 transition-colors"
                  (mousedown)="
                    $event.preventDefault(); $event.stopPropagation()
                  "
                  (click)="
                    addAllAdditionalFilters();
                    $event.preventDefault();
                    $event.stopPropagation()
                  ">
                  <fa-icon
                    [icon]="faFilter"
                    class="text-base-content/40 text-xs w-4 text-center shrink-0"></fa-icon>
                  <div class="flex flex-col gap-0.5">
                    <span class="font-semibold text-sm">All</span>
                  </div>
                </button>
                <div class="h-px bg-base-200 mx-3 my-2"></div>
              }
              @for (config of filteredAdditionalFilters(); track config.name) {
                <button
                  type="button"
                  class="flex w-[calc(100%-1rem)] items-center gap-3 p-3 text-left transition-all duration-200 ease-in-out rounded-xl mx-2 hover:bg-base-200"
                  (mousedown)="
                    $event.preventDefault(); $event.stopPropagation()
                  "
                  (click)="
                    addAdditionalFilter(config.name);
                    $event.preventDefault();
                    $event.stopPropagation()
                  ">
                  <fa-icon
                    [icon]="$any(config.icon || faFilter)"
                    class="text-base-content/40 text-xs w-4 text-center shrink-0"></fa-icon>
                  <div class="flex-1 min-w-0">
                    <div class="font-semibold text-xs truncate">
                      {{ config.title || config.name }}
                    </div>
                  </div>
                </button>
              }
              @if (filteredAdditionalFilters().length === 0) {
                <div
                  class="flex items-center justify-center p-8 text-base-content/50">
                  @if (optionsQuery.isLoading() || optionsQuery.isFetching()) {
                    <span class="loading loading-spinner loading-sm"></span>
                  } @else {
                    <span class="text-sm">No filters found</span>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    }

    @if (hasAnyActiveFilter() || hasExternalActiveFilters()) {
      <button
        type="button"
        class="text-xs text-base-content/40 font-medium cursor-pointer transition-colors duration-200 hover:text-error px-2 py-1 rounded-full shrink-0 self-end mb-1"
        (click)="clearAllFilters()"
        [attr.aria-label]="clearAriaLabel()">
        {{ clearLabel() }}
      </button>
    }
  </div>

  <div class="shrink-0 w-full sm:w-auto self-end">
    <ng-container #secondaryFiltersContainer></ng-container>
  </div>
</div>
